import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './LegalPage.css';

const LegalPageLayout = ({ title, lastUpdated, lead, toc, children }) => (
  <div className="legal-page">
    <Navbar />
    <main className="legal-page__main">
      <div className={`legal-page__container${toc?.length ? ' legal-page__container--with-toc' : ''}`}>
        {toc?.length > 0 && (
          <aside className="legal-page__toc" aria-label="On this page">
            <p className="legal-page__toc-label">On this page</p>
            <nav>
              {toc.map((item) => (
                <a key={item.id} href={`#${item.id}`}>
                  {item.label}
                </a>
              ))}
            </nav>
          </aside>
        )}

        <div className="legal-page__body">
          <header className="legal-page__header">
            <p className="legal-page__brand">
              <span className="legal-page__brand-mark" aria-hidden="true" />
              UBSAAPP
            </p>
            <p className="legal-page__breadcrumb">
              <Link to="/">Home</Link>
              <span aria-hidden="true"> / </span>
              <span>{title}</span>
            </p>
            <h1>{title}</h1>
            {lead && <p className="legal-page__lead">{lead}</p>}
            {lastUpdated && <p className="legal-page__updated">Last updated: {lastUpdated}</p>}
          </header>
          <article className="legal-page__content">{children}</article>
          <footer className="legal-page__footer-links">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <Link to="/sitemap">Sitemap</Link>
            <Link to="/help">Help Centre</Link>
          </footer>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default LegalPageLayout;
